import { ColorPicker } from '../../../../../primitives/color-picker';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

import { cn } from '../../../../../utils/cn';

import { EMAIL_COLORS } from '../../constants/colors';

type AppearanceProps = {
  backgroundColor?: string;
  className?: string;
  onBackgroundColorChange?: (backgroundColor?: string | null) => void;
};

export function Appearance({
  backgroundColor,
  className,
  onBackgroundColorChange,
}: AppearanceProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-xs font-medium">Apariencia</p>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1">
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Fondo
          </LabelWithoutRef>
          <ColorPicker
            colors={EMAIL_COLORS}
            isCleanColorVisible
            noneColorLabel="Sin personalizar"
            value={backgroundColor}
            onValueChange={(value) => onBackgroundColorChange?.(value ?? null)}
          />
        </div>
      </div>
    </div>
  );
}
